module.exports = __webpack_public_path__ + "img/huailai03.59831767.png";